import { Routes, Route } from "react-router-dom";

import OnionsPicture from "../views/OnionsPicture";
import OnionPage from "../views/OnionPage";
import OnionData from "../static/members.json";

const Main = () => (
  <Routes>
    <Route path="/" element={<OnionsPicture />}></Route>
    <Route
      path="/onions"
      element={
        <OnionPage
          onions={{ alexeshoo: OnionData[0], dennisdunne: OnionData[1] }}
        />
      }
    ></Route>
    })}
  </Routes>
);

export default Main;
